import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=d8b37cdc&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=ts&"
export * from "./orderList.vue?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=d8b37cdc&lang=scss&scoped=true&"
import style1 from "./orderList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b37cdc",
  null
  
)

export default component.exports